import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookie from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui 英文
import elementTwLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui 中文繁體
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui 中文簡體

import enLocale from './en'
import twLocale from './zh-tw'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  eng: {
    ...enLocale,
    ...elementEnLocale
  },
  cht: {
    ...twLocale,
    ...elementTwLocale
  },
  chs: {
    ...zhLocale,
    ...elementZhLocale
  },
}
// 獲取後台返回多語言cookie
export function getLanguage() {
  /*
  const chooseLanguage =Cookie.get(Cookie.get("current_login_id") + "language_code");
  if (chooseLanguage) return chooseLanguage

  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }*/
  // 默認繁體
  return 'cht'
}
const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
  silentTranslationWarn: true
})

export default i18n
